module.exports = __webpack_public_path__ + "static/media/scooter.8cbacf74.svg";